import{GALLERY_TYPE as E,IMAGE_TYPE as d}from"ricos-content";const e=(p={},n)=>{const{onExpand:o}=p;o&&(n[E]&&(n[E].onExpand=o),n[d]&&(n[d].onExpand=o),delete p.onExpand)};export{e as deprecateHelpers};
